import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { heroSlides } from '../mock';
import { useLang } from '../hooks/useLang';
import { pickLocalized } from '../i18n';

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { t } = useTranslation();
  const { lang } = useLang();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {heroSlides.map((slide, index) => {
        const title = pickLocalized(slide, 'title', lang);
        const description = pickLocalized(slide, 'description', lang);
        return (
          <div key={slide.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`}>
            <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${slide.image})` }}>
              <div className="absolute inset-0 bg-black bg-opacity-30"></div>
            </div>
            <div className="relative h-full flex items-center">
              <div className="max-w-[1920px] mx-auto px-8 lg:px-16 w-full">
                <div className="max-w-2xl">
                  <h1 className="text-5xl lg:text-7xl font-light text-white mb-6 leading-tight">{title}</h1>
                  <p className="text-lg lg:text-xl font-light text-white text-opacity-90 leading-relaxed">{description}</p>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <button onClick={prevSlide} aria-label={t('common.previousSlide')}
        className="absolute left-8 lg:left-16 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white bg-opacity-10 hover:bg-opacity-20 transition-all duration-300 backdrop-blur-sm">
        <ChevronLeft className="w-6 h-6 text-white" />
      </button>
      <button onClick={nextSlide} aria-label={t('common.nextSlide')}
        className="absolute right-8 lg:right-16 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white bg-opacity-10 hover:bg-opacity-20 transition-all duration-300 backdrop-blur-sm">
        <ChevronRight className="w-6 h-6 text-white" />
      </button>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex gap-3">
        {heroSlides.map((_, index) => (
          <button key={index} onClick={() => setCurrentSlide(index)}
            className={`h-1 transition-all duration-300 ${index === currentSlide ? 'w-12 bg-white' : 'w-8 bg-white bg-opacity-50'}`}
            aria-label={`Go to slide ${index + 1}`} />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;